var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-products"},[(_vm.loaded)?_c('carousel',{attrs:{"nav":false,"loop":false,"center":false,"margin":20,"responsive":{
                  0:{items:1, stagePadding:50, touchDrag: true},
                  768:{items:2},
                  1200:{items:3}
              }}},_vm._l((_vm.products),function(product){return ((_vm.includeGiftcard || product.id !== 5) && product.locale_price)?_c('carousel-card',{key:product.id,attrs:{"product":product}}):_vm._e()}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }